/**
 * Navigates the current window to the given url. Wrapped so tests can mock
 * navigation, since jsdom doesn't allow stubbing `window.location.assign`.
 */
export function navigateTo(url: string) {
  window.location.assign(url)
}
